/**
 * Ponteiros para o repositório.
 *
 * Estes links apontam para o repositório FONTE (`ronidomingues/dpgen`), e não
 * para o repositório onde o site é publicado (`andradasdev/dpgen`). O de destino
 * recebe só o conteúdo de `dist/` — o workflow o reescreve inteiro a cada deploy
 * (`force_orphan`), então `spec/`, `reference.mjs` e `LICENSE` não existem lá.
 *
 * Apontar para o destino deixaria o rodapé cheio de 404, e um link quebrado numa
 * ferramenta de segurança é pior que link nenhum: a auditabilidade é o argumento
 * central da página.
 */
export const REPO_URL = 'https://github.com/ronidomingues/dpgen'

export const SPEC_URL = `${REPO_URL}/blob/main/spec/dpgen-v1.md`
export const REFERENCE_URL = `${REPO_URL}/blob/main/spec/reference.mjs`
export const LICENSE_URL = `${REPO_URL}/blob/main/LICENSE`
